import config from '../../../config'
import http from './http-util'

class PriceInfoMailServiceApi {
  static sendMail = (paymentMethodId, months, amount, email) => token => {
    const request = {
      amount,
      channelType: 'MERCHANT_PORTAL',
      email,
      paymentMethod: paymentMethodId,
      repaymentPeriod: months,
    }
    return http.post(
      token,
      `${config.priceInfoMailServiceUrl}/priceinfo_mail`,
      JSON.stringify(request),
    )
  }
}

export default PriceInfoMailServiceApi
